import { createSlice } from '@reduxjs/toolkit';

const initialState: string = null as any;

const blockDraggedSlice = createSlice({
	name: 'blockDragged',
	initialState,
	reducers: {
		setBlockDragged: (state, action) => {
			return action.payload;
		},
		resetBlockDragged: () => initialState
	}
});

export const { setBlockDragged, resetBlockDragged } = blockDraggedSlice.actions;
export default blockDraggedSlice.reducer;
